module.exports = __webpack_public_path__ + "static/img/p7.b8e9134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/patent/p7.png
// module id = KxbY
// module chunks = 0